/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Select,
  DatePicker,
  Spin,
  Upload,
  Radio,
  Modal,
} from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  capitalize,
  checkAlphabets,
  checkNumbervalue,
  checkSpace,
  capitalise,
  checkSpecialCharacter,
  firstLetterCapitalise,
  getUserAndPremiseId,
} from "../../../utils";

import uploadLogo from "../../../assests/images/bx_upload.svg";

import axios from "axios";
import { APIs, getPremiseId, getToken } from "../../../utils/worker";
import moment from "moment";
import { getStaffOnboardClear } from "../../../actionsMethods/onboardingMethods";
import API from "../../../api";
import urls from "../../../api/urls";
import { useNavigate } from "react-router-dom";

const {
  UPDATE_STAFF,
  VERIFY_EMAIL,
  GET_BANK_DETAILS_BY_IFSC,
  VERIFY_PHONE_NUM,
  SEND_SMS_PHONE,
  VERIFY_PHONE_OTP,
  GET_STAFF_ROLES,
} = urls;

const { Dragger } = Upload;

export const CreateStaff = ({ changeTab = () => {}, formResult }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const premiseId = getPremiseId();
  const getUserInfo = getUserAndPremiseId();
  const userId = getUserInfo?.userId;
  const token = getToken();

  const [visible, setVisible] = useState(false);
  const dateFormat = "DD/MM/YYYY";
  const [roleOptions, setRoleOptions] = useState();
  const getStaffId = localStorage.getItem("staff");
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const [driverSelected, setdriverSelected] = useState(false);
  const [showVerify, setShowVerify] = useState();
  const [showBank, setshowBank] = useState();
  const [phnOtpVerified, setPhnOtpVerified] = useState(false);
  const [selectedId, setselectedId] = useState();
  const [loading, setloading] = useState(false);
  const [roleSelected, setRoleSelected] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [fileList, setfileList] = useState([]);
  const fileNamePan = formResult?.idUrl?.toString("")?.split("/");

  const [idTypes, setIdTypes] = useState([
    {
      label: "Aadhar card",
      value: "aadhar",
    },
    {
      label: "Voter Id",
      value: "VOTER",
    },
    {
      label: "PAN Card",
      value: "pan",
    },
    {
      label: "Driving Licence",
      value: "DL",
    },
  ]);

  const [dlClass, setDelClass] = useState([
    {
      label: "MC 50CC",
      value: "MC 50CC",
    },
    {
      label: "MCWOG/FVG",
      value: "MCWOG/FVG",
    },
    {
      label: "MC EX50CC",
      value: "MC EX50CC",
    },
    {
      label: "MGV",
      value: "MGV",
    },
    {
      label: "HMV",
      value: "HMV",
    },

    {
      label: "LMV",
      value: "LMV",
    },
    {
      label: "HTV",
      value: "HTV",
    },
    {
      label: "Trailer",
      value: "Trailer",
    },
  ]);
  const [idTypesMain, setIdTypesMain] = useState([
    {
      label: "Aadhar card",
      value: "aadhar",
    },
    {
      label: "Voter Id",
      value: "VOTER",
    },
    {
      label: "PAN Card",
      value: "pan",
    },
    {
      label: "Driving License",
      value: "DL",
    },
  ]);

  useEffect(() => {
    getALLRoles();
  }, []);

  useEffect(() => {
    modalForm.resetFields();
    if (visible === true) {
      setPhnOtpVerified(false);
    }
  }, [visible]);

  useEffect(() => {
    if (formResult) {
      form.setFieldsValue(formResult);
      form.setFieldsValue("bankDetail", false);
      if (formResult.label == "DRIVER") {
        setdriverSelected(true);
      }
      setselectedId(formResult?.idType);
      setshowBank(formResult?.bankDetail || false);
      form.setFieldValue(
        "dateOfBirth",
        formResult?.dateOfBirth
          ? moment(formResult?.dateOfBirth, "DD/MM/YYYY")
          : null
      );
    } else {
      form.resetFields();
    }
  }, [formResult]);

  const getALLRoles = async () => {
    let response = await API.Api(GET_STAFF_ROLES).getWithUserNPremiseHeader();
    if (response.status) {
      let temp = response?.response?.data?.map((val, idx) => {
        return { label: capitalize(val?.label), value: val?.role };
      });
      setRoleOptions(temp);
    } else {
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const verifyEmailExists = async (values) => {
    let response = await API.Api(VERIFY_EMAIL).post({
      emailId: values,
    });
    if (response.status) {
      if (response.response.data === false) {
        message.error("E-mail already exists");
      } else {
        setShowVerifyEmail(true);
      }
    }
  };

  const checkPhnNumExists = async (values) => {
    let response = await API.Api(VERIFY_PHONE_NUM).post({
      contactNumber: values,
    });
    if (response.status) {
      if (response.response.data === false) {
        message.error("Phone number already exists");
      } else {
        // sentPhoneOtp(values);
        setShowVerify(true);
      }
    }
  };
  const sentPhoneOtp = async () => {
    let phoneNum = form.getFieldValue("contactNumber");

    let response = await API.Api(SEND_SMS_PHONE).post({
      mobileNo: phoneNum,
    });

    if (response.response.data === true) {
      message.info("OTP has sent the given number");
    } else {
      message.error("Failed to send the OTP");
    }
  };

  const createPersonalDetails = async (values) => {
    setloading(true);
    setloading;
    let convertToDate = (date) => {
      let today = new Date(date);
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      today = `${dd}/${mm}/${yyyy}`;
      return today;
    };

    // console.log(values?.dlClass.toString(), " values.alas");

    let mainPayload = {
      ...values,
      dlClass: values?.dlClass?.toString() || null,
      dateOfBirth: convertToDate(values?.dateOfBirth?._d),
    };

    if (formResult === null) {
      try {
        let response = await axios.post(
          APIs.baseURL + "/staff-service/v1/staff",
          mainPayload,
          {
            headers: {
              Authorization: token,
              "SMCS-PREMISE-ID": premiseId.split("Bearer")[1],
              "USER-ID": userId,
            },
          }
        );
        if (response.status === 200) {
          localStorage.setItem("staff", response?.data?.data?.staffId);
          message.success("Satff onboarded successfully");

          setloading(false);
          changeTab("2");
        }
      } catch (error) {
        message.error(error?.response?.data?.message);
        setloading(false);
      }
    } else {
      let patchPayload = {
        ...values,
        dlClass: values?.dlClass?.toString() || null,
        staffId: getStaffId,
        dateOfBirth: convertToDate(values?.dateOfBirth?._d),
      };
      updateStaffOnboard(patchPayload);
    }
  };

  const updateStaffOnboard = async (values) => {
    let response = await API.Api(UPDATE_STAFF).patchIdHeader(values);
    if (response.status) {
      message.success(response?.response?.data?.message);
      changeTab("2");
    }
  };

  const handleCloseModal = (params) => {
    setVisible(false);
  };

  const verifyPhoneOtp = async (values) => {
    let phoneNum = form.getFieldValue("contactNumber");
    let response = await API.Api(VERIFY_PHONE_OTP).post({
      mobileNo: phoneNum,
      otp: values.otp,
    });

    if (response.response.data === true) {
      message.success("Phone number verified successfully");
      setPhnOtpVerified(true);
      setVisible(false);
      setShowVerify(false);
    } else {
      message.error("Wrong OTP");
    }
  };

  function handleSelectedId(params) {
    setselectedId(params);
    form.setFieldValue("idNumber", null);
  }

  const IDInput = () => {
    switch (selectedId) {
      case "pan":
        return (
          <Form.Item
            name="idNumber"
            label="PAN Card"
            rules={[
              {
                message: "Please enter pan number",
                required: true,
                pattern: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/g,
              },
            ]}
          >
            <Input
              placeholder="Enter pan number"
              maxLength={16}
              onKeyPress={(event) => {
                if (checkSpace(event) || checkSpecialCharacter(event)) {
                  event.preventDefault();
                }
              }}
              disabled={formResult?.idNumber || !selectedId ? true : false}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        );
      case "VOTER":
        return (
          <Form.Item
            name="idNumber"
            label="Voter ID"
            rules={[
              {
                message: "Please enter ID number",
                required: true,
                pattern: /^[A-Z]{3}[0-9]{7}$/g,
              },
            ]}
          >
            <Input
              placeholder="Enter Voter ID"
              maxLength={16}
              onKeyPress={(event) => {
                if (checkSpace(event) || checkSpecialCharacter(event)) {
                  event.preventDefault();
                }
              }}
              disabled={formResult?.idNumber || !selectedId ? true : false}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        );
      case "DL":
        return (
          <Form.Item
            name="idNumber"
            label="Driving licence"
            rules={[
              {
                message: "Please enter valid DL number",
                required: true,
              },
            ]}
          >
            <Input
              placeholder="Ex:KA32 20210011055"
              maxLength={16}
              style={{ textTransform: "uppercase" }}
              onKeyPress={(event) => {
                if (checkSpace(event) || checkSpecialCharacter(event)) {
                  event.preventDefault();
                }
              }}
              disabled={formResult?.idNumber || !selectedId ? true : false}
              // onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        );

      default:
        return (
          <Form.Item
            name="idNumber"
            label="Aadhar number"
            rules={[
              {
                message: "Please enter aadhar number",
                required: true,
                pattern:
                  /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/g,
              },
            ]}
          >
            <Input
              placeholder="Enter aadhar number"
              maxLength={12}
              onKeyPress={(event) => {
                if (
                  checkSpecialCharacter(event) ||
                  checkSpace(event) ||
                  checkNumbervalue(event)
                ) {
                  event.preventDefault();
                }
              }}
              disabled={formResult?.idNumber || !selectedId ? true : false}
            />
          </Form.Item>
        );
    }
  };

  const propsPan = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,
    action: `${APIs.baseURL}/staff-service/v1/staff/${"PAN"}`,
    className: "upload-list-inline",
    fileList: formResult?.idUrl
      ? [
          {
            name: fileNamePan && fileNamePan[fileNamePan?.length - 1],
            url: formResult?.idUrl,
          },
        ]
      : fileList,
  };

  const handleChange = (info) => {
    if (info.file.status === "done") {
      form.setFieldValue("idUrl", info.file.response);
      message.success(
        info.file.response.message || "Document uploaded successully"
      );
    }
    if (info.file.status === "error") {
      message.error("File not Supported");
    }
    setfileList(info.fileList);
  };

  function handleRemoveFile() {
    message.success("File removed successfully");
    setfileList([]);
  }

  const headers = {
    Authorization: token,
    "SMCS-PREMISE-ID": premiseId?.split("Bearer")[1],
    "USER-ID": userId,
  };

  function handleRadioChange(e) {
    setshowBank(true);
    if (e.target.value === false) {
      setshowBank(false);
      form.setFieldValue("bankDetail", false);
      form.setFieldsValue({
        accountHolderName: "",
        accountNumber: "",
        ifscCode: "",
        bankName: "",
        branchName: "",
      });
    } else {
      form.setFieldValue("bankDetail", true);
    }
  }

  const checkIFSC = async (values) => {
    let response = await API.Api(
      GET_BANK_DETAILS_BY_IFSC + `?ifscCode=${values}`
    ).get();
    if (response.status) {
      setBankDetails(response.response.data);
    } else {
      form.setFieldsValue({
        bankName: "",
        branchName: "",
      });
    }
  };

  useEffect(() => {
    if (bankDetails?.IFSC) {
      form.setFieldsValue({
        bankName: bankDetails?.BANK,
        branchName: bankDetails?.BRANCH,
      });
    }
  }, [bankDetails]);

  function handleRoleChange(e) {
    setRoleSelected(e);
    form.setFieldsValue({
      idType: null,
      idNumber: null,
    });

    // console.log(e, "e");
    if (!e.includes("ROLE_CPOPERATOR")) {
      setdriverSelected(true);
      let filterId = idTypes?.filter((val) => val.value === "DL");
      setIdTypes([...filterId]);
    } else {
      setdriverSelected(false);
      setIdTypes([...idTypesMain]);
    }
  }

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = (file) => {
    console.log(file, "file");
    if (file.type == "application/pdf" || file.name.split(".")[1] == "pdf") {
      window.open(file.url || file.response);
    } else {
      setPreviewImage(file.thumbUrl || file.url);
      setPreviewOpen(true);
      setPreviewTitle(
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
      );
    }
  };
  const handleCancel = () => setPreviewOpen(false);

  const beforeUpload = (file, onSuccess, onError) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file.name);

      if (file.name.includes("jfif")) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        message.error("File size should be less than 10MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        message.error("File not supported");
        return Upload.LIST_IGNORE;
      }
      return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };

  const date = new Date();
  const sub = moment(date).subtract(18, "years");
  const minDate = sub;
  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }
      return minDate != null && d.isAfter(minDate) && !d.isSame(minDate, "day");
    },
    [minDate]
  );

  return (
    <Spin spinning={loading}>
      <div>
        <Modal
          open={previewOpen}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewImage}
          />
        </Modal>
        <Modal
          title={null}
          open={visible}
          maskClosable={false}
          onCancel={handleCloseModal}
          width={400}
          loading={false}
          className="staff-onboard-modal"
          footer={
            <>
              <div className="d-flex flex-end">
                <Button
                  htmlType="submit"
                  onClick={modalForm.submit}
                  className="save-btn ml-1"
                >
                  SUBMIT
                </Button>
              </div>
            </>
          }
        >
          <div>
            <Form
              form={modalForm}
              onFinish={verifyPhoneOtp}
              layout={"vertical"}
              className="global-form"
            >
              <Row
                justify=""
                span={24}
                className="global-form-row mt-2"
                gutter={20}
                style={{ padding: "0 30px" }}
              >
                <Col span={24}>
                  <Form.Item
                    name="otp"
                    label="OTP"
                    rules={[
                      {
                        message: "OTP is required",
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter OTP"
                      onChange={"handlePincodeInput"}
                      maxLength={6}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
        <Form
          className="global-form profile-container-form pl-4 pr-4 p-2"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createPersonalDetails}
        >
          <Row gutter={40} className="global-form-row">
            <Col span={24} className="mb-1">
              <span className="master-title">Personal Details</span>
              <hr className="divider" />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="firstName"
                label="First name"
                rules={[
                  {
                    required: true,
                    message: null,
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.length < 3) {
                        return Promise.reject("Please enter first name");
                      }
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Please enter valid name");
                      } else {
                        return Promise.resolve();
                      }
                    },
                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Please enter first name"
                  maxLength={30}
                  onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="lastName"
                label="Last name"
                rules={[
                  {
                    required: true,
                    message: null,
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.length < 3) {
                        return Promise.reject("Please enter last name");
                      }
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Please enter valid name");
                      } else {
                        return Promise.resolve();
                      }
                    },
                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Please enter last name"
                  maxLength={30}
                  onInput={(e) => (e.target.value = firstLetterCapitalise(e))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="dateOfBirth"
                label="Date of birth"
                rules={[
                  {
                    required: true,
                    message: "Please select date of birth",
                  },
                ]}
              >
                <DatePicker
                  format={dateFormat}
                  // disabledDate={(current) => {
                  //   const start = moment("2004-01-01", "YYYY-MM-DD");
                  //   return current >= start || current > moment();
                  // }}
                  // defaultPickerValue={moment("2003-01-01")}

                  disabledDate={disableDaysBeforeToday}
                  defaultPickerValue={minDate}
                />
              </Form.Item>
            </Col>

            <Col xs={9} sm={9} md={9} lg={9} xl={9}>
              <Form.Item
                name="contactNumber"
                label="Contact number"
                hasFeedback={phnOtpVerified}
                validateStatus="success"
                rules={[
                  {
                    required: true,
                    message: "Please enter contact number",
                  },
                  {
                    pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                    message: "Invalid contact number",
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                  placeholder="Enter contact number"
                  maxLength={10}
                  disabled={formResult !== null}
                  onChange={(e) => {
                    if (e.target.value.length === 10) {
                      checkPhnNumExists(e.target.value);
                    } else {
                      // phnOtpVerified
                      setPhnOtpVerified(false);
                      setShowVerify(false);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {formResult === null ? (
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <Form.Item
                  label={<span style={{ visibility: "hidden" }}>.</span>}
                >
                  <Button
                    className="btn-style cancel-btn"
                    onClick={() => {
                      setVisible(true);
                      sentPhoneOtp();
                    }}
                    disabled={!showVerify}
                  >
                    VERIFY
                  </Button>
                </Form.Item>
              </Col>
            ) : null}
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form.Item
                name="alternativeNumber"
                label="Alternate contact no."
                rules={[
                  {
                    required: false,
                    message: "Please enter a valid phone number",
                  },
                  {
                    pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                    message: "Invalid contact number",
                  },
                ]}
                onKeyPress={(event) => {
                  if (/[^0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter secondary phone number"
                  maxLength={10}
                />
              </Form.Item>
            </Col>

            <Col xs={9} sm={9} md={9} lg={9} xl={9}>
              <Form.Item
                name="emailId"
                label="Email ID"
                type="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter a email id",
                  },
                  {
                    type: "email",
                    message: "The input is not valid E-mail",
                    validateTrigger: "onSubmit",
                  },
                ]}
                onKeyPress={(event) => {
                  if (checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter email"
                  maxLength={30}
                  disabled={formResult !== null}
                  onChange={(e) => {
                    if (e.target.value.length > 10) {
                      verifyEmailExists(e.target.value);
                    } else {
                      setShowVerifyEmail(false);
                    }
                  }}
                  onInput={(e) =>
                    (e.target.value = e.target.value.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="role"
                label="Role"
                rules={[
                  {
                    message: "Please select nature of business",
                    required: true,
                  },
                ]}
              >
                <Select
                  onChange={handleRoleChange}
                  placeholder="Select role of client"
                  options={roleOptions}
                  disabled={formResult !== null}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form.Item
                name="idType"
                label="Select ID"
                rules={[
                  {
                    message: "Please select ID",
                    required: formResult ? false : true,
                  },
                ]}
              >
                <Select
                  placeholder="Select ID"
                  options={idTypes}
                  onChange={handleSelectedId}
                  disabled={
                    formResult?.idNumber || !roleSelected ? true : false
                  }
                />
              </Form.Item>
            </Col>
            {driverSelected && (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Form.Item
                  name="dlClass"
                  label="DL Class"
                  rules={[
                    {
                      message: "Please enter Dl class",
                      required: formResult ? false : true,
                    },
                  ]}
                >
                  <Select
                    placeholder="Select ID"
                    mode="multiple"
                    options={dlClass}
                    // onChange={handleSelectedId}
                    disabled={
                      formResult?.idNumber || !roleSelected ? true : false
                    }
                  />
                </Form.Item>
              </Col>
            )}

            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <IDInput />
            </Col>

            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form.Item
                name="idUrl"
                label="Upload file"
                rules={[
                  {
                    message: "Upload file",
                    required: true,
                  },
                ]}
              >
                <div className="one-row">
                  <Dragger
                    {...propsPan}
                    className=""
                    onChange={handleChange}
                    onRemove={handleRemoveFile}
                    disabled={formResult?.idUrl}
                    maxCount={1}
                    onPreview={handlePreview}
                    // onPreview={(a) => navigate(a?.response)}
                    // onPreview={(item) =>
                    //   window.open(item?.response || item?.url)
                    // }
                    // onPreview={(item) => console.log(item, "url")}
                    beforeUpload={beforeUpload}
                    multiple={false}
                    headers={headers}
                  >
                    <Row>
                      <Col
                        span={6}
                        className="m-auto"
                        style={{ borderRight: "1px solid #CECECE" }}
                      >
                        <img
                          src={uploadLogo}
                          className="Upload-logo"
                          style={{ width: "40px", height: "40px" }}
                        />
                      </Col>
                      <Col span={18} className="f-13">
                        <p>Click to upload or drag and drop</p>
                        {/* <p>Maximum file size 10 MB</p> */}
                        <p>
                          Supported file type: PDF, JPEG, PNG and Max 5MB file
                          size
                        </p>
                      </Col>
                    </Row>
                  </Dragger>
                </div>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-1">
              <h3>Do you wish to add bank details of this staff</h3>
              <Form.Item name={"bankDetail"} label="">
                <Radio.Group defaultValue={false} onChange={handleRadioChange}>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <div style={{ display: !showBank ? "none" : "contents" }}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="accountHolderName"
                  label="Account holder’s name"
                  rules={[
                    {
                      message: "Please enter name",
                      required: showBank ? true : false,
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (checkSpecialCharacter(event) || checkAlphabets(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Enter name"
                    onInput={(e) => (e.target.value = capitalise(e))}
                    // disabled={!bankRequired}
                    maxLength={30}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="accountNumber"
                  label="Account number"
                  rules={[
                    {
                      message: "Please enter account number",
                      required: showBank ? true : false,
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter account number"
                    // disabled={!bankRequired}
                    maxLength={18}
                    onKeyPress={(event) => {
                      if (
                        checkSpecialCharacter(event) ||
                        checkSpace(event) ||
                        checkNumbervalue(event)
                      ) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="ifscCode"
                  label="IFSC code"
                  rules={[
                    {
                      required: showBank ? true : false,
                      message: "Please enter IFSC code",
                    },
                    {
                      pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/g,
                      message: "Please enter valid IFSC code",
                    },
                  ]}
                  onKeyPress={(event) => {
                    if (checkSpecialCharacter(event) || checkSpace(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Enter IFSC code"
                    onChange={(event) => {
                      if (event.target.value.length > 10) {
                        checkIFSC(event.target.value);
                      } else {
                        form.setFieldsValue({
                          bankName: "",
                          branchName: "",
                        });
                      }
                    }}
                    maxLength={12}
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="bankName"
                  label="Bank name"
                  // rules={[
                  //   {
                  //     required: showBank ? true : false,
                  //     message: "Please enter bank name",
                  //     validateTrigger: "onSubmit",
                  //   },
                  // ]}
                >
                  <Input
                    placeholder="Please enter bank name"
                    maxLength={30}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="branchName"
                  label="Branch name"
                  // rules={[
                  //   {
                  //     required: showBank ? true : false,
                  //     message: "Please enter branch name",
                  //   },
                  // ]}
                >
                  <Input
                    placeholder="Enter branch name"
                    maxLength={30}
                    disabled
                  />
                </Form.Item>
              </Col>
            </div>
          </Row>
          <hr className="divider" />
          <div className="d-flex flex-end mt-1">
            <Button
              className="btn-style cancel-btn ml-1 w-10"
              onClick={() => {
                localStorage.setItem("staff", null);
                dispatch(getStaffOnboardClear());
                form.resetFields();
                navigate("/onboarding-settings");
              }}
            >
              CANCEL
            </Button>
            <Button
              htmlType="submit"
              className={
                formResult === null && !phnOtpVerified
                  ? "btn-style ml-1 w-10"
                  : " save-btn ml-1"
              }
              // onClick={handleStepsChange}
              disabled={formResult === null && !phnOtpVerified}
            >
              SUBMIT
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default CreateStaff;
